// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"infoBox_infoWrapper__2bg8A","audioButton":"infoBox_audioButton__2Gyr8"};